<template>
  <div>
    <a-select
      :disabled="disabled"
      :multiple="false"
      :placeholder="placeholder"
      :value="value"
      allow-clear
      option-filter-prop="title"
      show-search
      @change="onChange"
    >
      <a-select-option
        v-for="item in data?.records"
        :key="item.id"
        :title="item.name"
        :value="item.id"
      >
        {{ item.name }}
      </a-select-option>
    </a-select>
  </div>
</template>

<script lang="ts">
import { defineComponent, watch } from "vue";
import { ContractSimpleListReq, ProfileService } from "@/views/contract";

/**
 * 合同选择器
 */
export default defineComponent({
  name: "SupplierContractSelect",
  props: {
    value: {
      type: String,
      default: undefined,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    placeholder: {
      type: String,
      default: "请选择",
    },

    supplierId: {
      type: String,
      default: "",
    },

    // 下拉履约中传 0
    type: {
      type: String,
      default: "",
    },
    addRightBizType: {
      type: String,
      default: undefined,
    },
  },
  emits: ["update:value", "change"],
  setup(props, { emit }) {
    const { data, run, loading } = ProfileService.useSupplierContractsApi();

    const onChange = async (id) => {
      emit("update:value", id);
      emit("change", id);
    };

    const search = async () => {
      if (!props.supplierId) {
        return;
      }
      const req = new ContractSimpleListReq();
      if (props.supplierId) {
        req.merge({ supplierIds: props.supplierId, type: props.type });
      }
      if(props.addRightBizType){
        req.merge({ addRightBizType: props.addRightBizType });
      }
      await run(req);
    };

    watch(
      () => props.supplierId,
      async () => {
        await search();
      },
      { immediate: true }
    );

    return {
      data,
      loading,
      onChange,
    };
  },
});
</script>
